"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var diagnosis_service_1 = require("./diagnosis.service");
var Subject_1 = require("rxjs/Subject");
var find_http_error_1 = require("../../shared/error/find-http-error");
var http_request_builder_1 = require("../../core/http-request-builder");
var VehicleService = /** @class */ (function () {
    function VehicleService(_http) {
        this._http = _http;
        this.FIND_VEHICLES_BY_USER = diagnosis_service_1.DiagnosisService.DIAGNOSIS_END_POINT + '/getVehiclesByUser';
        this.findSubject = new Subject_1.Subject();
        this.find$ = this.findSubject.asObservable();
        this.errorSubject = new Subject_1.Subject();
        this.error$ = this.errorSubject.asObservable();
    }
    VehicleService.prototype.getVehiclesByUser = function (userId, diagnosisType) {
        var _this = this;
        this._http.get(this.FIND_VEHICLES_BY_USER + "/" + userId + "/" + diagnosisType)
            .subscribe(function (vehicles) { return _this.findSubject.next(vehicles.json()); }, function (error) { return _this.errorSubject.next(new find_http_error_1.FindHttpError(error._body)); });
    };
    VehicleService.ctorParameters = function () { return [{ type: http_request_builder_1.HttpRequestBuilder }]; };
    return VehicleService;
}());
exports.VehicleService = VehicleService;
//# sourceMappingURL=vehicle.service.js.map


// WEBPACK FOOTER //
// vehicle.service.js